module.exports = __webpack_public_path__ + "img/26_145.39e968ee.png";